import {
  IconMetroEkb16,
  IconMetroKzn16,
  IconMetroMsk16,
  IconMetroNN16,
  IconMetroNovosib16,
  IconMetroSam16,
  IconMetroSpb16,
} from '@cian/ui-kit';

const UNDERGROUND_BY_SUBDOMAIN = {
  www: IconMetroMsk16,
  ekb: IconMetroEkb16,
  kazan: IconMetroKzn16,
  nn: IconMetroNN16,
  novosibirsk: IconMetroNovosib16,
  samara: IconMetroSam16,
  spb: IconMetroSpb16,
};

type ISubdomain = keyof typeof UNDERGROUND_BY_SUBDOMAIN;

export const getUndergroundIconBySubdomain = (subdomain: string) =>
  UNDERGROUND_BY_SUBDOMAIN[subdomain as ISubdomain] || UNDERGROUND_BY_SUBDOMAIN['www'];
